import { useDroppable } from '@dnd-kit/core';
import { Box } from '@mui/material';
import { PRIMARY, RED } from 'constants/colors';
import dayjs from 'dayjs';
import {
  AvailabilityResponse,
  PlanningEntityIdentifier,
  PlanningEntityType
} from 'generated/index';
import { ElementType } from 'react';
import { useTranslation } from 'react-i18next';
import { brightness } from 'utils/misc';

const Availability = ({
  id,
  availability,
  component,
  showTime,
  planningEntityType,
  planningEntityId,
  planningEntityIdentifier,
  scheduleStart
}: {
  id: string;
  availability: AvailabilityResponse;
  component?: ElementType<any>;
  showTime?: boolean;
  planningEntityType: PlanningEntityType;
  planningEntityId: string;
  planningEntityIdentifier: PlanningEntityIdentifier;
  scheduleStart: string;
}) => {
  const { t } = useTranslation('', { keyPrefix: 'activityPlanning' });

  const { setNodeRef, isOver } = useDroppable({
    id,
    disabled: !showTime,
    data: {
      planningEntityType,
      planningEntityId,
      planningEntityIdentifier,
      scheduleStart,
      isDroppableCell: true
    }
  });
  const isUnavailability = availability.type === 'NOT_AVAILABLE';

  return (
    <Box
      ref={setNodeRef}
      component={component || 'div'}
      display="flex"
      alignItems="center"
      sx={{
        boxSizing: 'border-box',
        color: isOver ? PRIMARY : '#023850',
        backgroundColor: isOver
          ? brightness(PRIMARY, 90)
          : isUnavailability
          ? brightness(RED, 90)
          : '#e8fee8',
        border: `2px solid ${isOver ? PRIMARY : 'transparent'}`,
        boxShadow: '0px 2px 8px rgba(0,0,0,0.15)',
        borderRadius: '6px',
        width: '100%',
        height: '40px',
        padding: '0 10px',
        '+ *': {
          marginTop: '8px'
        }
      }}
    >
      {!showTime
        ? t(isUnavailability ? 'fullDayUnavailable' : 'fullDayAvailable')
        : t(isUnavailability ? 'unavailableFromTil' : 'availableFromTil', {
            from: dayjs(availability.start).format('HH:mm'),
            to: dayjs(availability.end).format('HH:mm')
          })}
    </Box>
  );
};

export default Availability;
